import { Component, Inject, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DialogService } from '../../../../services/dialog.service';
import { Utils } from '../../../../utils/utils';
import { SaveService } from '../../../../services/save.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'controllerconfigpredefineditemsdescription-form',
    templateUrl: './controllerconfigpredefineditemsdescription-form.component.html',
    styleUrls: ['../../../../style/form.component.less'],
    standalone: false
})
export class ControllerConfigPredefinedItemsDescriptionFormComponent implements OnInit {

    body = {
        PredefinedItemBk: '',
        ControllerConfigPredefinedItemsDescriptionID: -1,
        ControllerConfigBK: ''
    };

    form!: FormGroup
    submitted = false;

    constructor(private http: HttpClient
        , private confimDialog: DialogService
        , private router: Router
        , @Inject(MAT_DIALOG_DATA) public data: any
        , @Inject('BASE_URL') private baseUrl: string
        , public dialogRef: MatDialogRef<ControllerConfigPredefinedItemsDescriptionFormComponent>
        , private formBuilder: FormBuilder

    ) {

        this.confimDialog.tthis = this;
        this.body.ControllerConfigBK = this.data.ControllerConfigBK
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            PredefinedItemBk: ['', [Validators.required]],
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.form)
            if (this.form.invalid) {
                return;
            }

        //const tthis: this;
        this.http
            .post<ControllerConfig>(
                this.baseUrl + Utils.getControllerTypeAPI() + "addcontrollerconfigpredefineditemsdescription"
                , this.body
            )
            .subscribe(
                res => {
                    this.onBack()
                    this.dialogRef.close({ event: 'submit' });
                }
                , error => {
                    this.confimDialog.showErrorDialog(error);
                }
            );
    }

    onBack() { }

    onNoClick(): void {
        this.dialogRef.close();
    }
}


